import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {LandingPageComponent} from "./components/landing-page/landing-page.component";
import {environment} from "../../../environments/environment";
import {LandingPageSettingsResponseResolver} from "./resolvers/landing-page-settings-response.resolver";
import {PageNotFoundComponent} from "fello-common";

const routes: Routes = [
  {
    path: ":landingPageConfigId",
    component: LandingPageComponent,
    resolve: {
      settings: LandingPageSettingsResponseResolver
    },
    data: {
      enableSubdomainFixing: environment.enableSubdomainFixing
    }
  },
  {
    path: "**",
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicLandingPageRoutingModule {}
